import * as styledComponents from "styled-components";

export const {
  default: styled,
  css,
  keyframes,
  ThemeProvider,
} = styledComponents;
